export default class OverlapBlock extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-overlap-block', OverlapBlock);
